// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuBarDeveloper h1::before {
  transform: scaleX(0);
  transform-origin: bottom right;
}

.MenuBarDeveloper h1:hover::before {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.MenuBarDeveloper h1::before {
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  inset: 0 0 0 0;
  background: hsl(200 100% 80%);
  z-index: -1;
  transition: transform 0.3s ease;
}

.MenuBarDeveloper h1 {
  position: relative;
  font-size: 4rem;
}

.MenuBarDeveloper html {
  block-size: 100%;
  inline-size: 100%;
}

.MenuBarDeveloper {
  min-block-size: 100%;
  min-inline-size: 100%;
  margin: 0;
  box-sizing: border-box;
  display: grid;
  place-content: center;
  font-family: system-ui, sans-serif;
}

@media (orientation: landscape) {
  body {
    grid-auto-flow: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/MenuBarDeveloper/MenuBarDeveloper.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,6BAA6B;EAC7B,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".MenuBarDeveloper h1::before {\n  transform: scaleX(0);\n  transform-origin: bottom right;\n}\n\n.MenuBarDeveloper h1:hover::before {\n  transform: scaleX(1);\n  transform-origin: bottom left;\n}\n\n.MenuBarDeveloper h1::before {\n  content: \" \";\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  inset: 0 0 0 0;\n  background: hsl(200 100% 80%);\n  z-index: -1;\n  transition: transform 0.3s ease;\n}\n\n.MenuBarDeveloper h1 {\n  position: relative;\n  font-size: 4rem;\n}\n\n.MenuBarDeveloper html {\n  block-size: 100%;\n  inline-size: 100%;\n}\n\n.MenuBarDeveloper {\n  min-block-size: 100%;\n  min-inline-size: 100%;\n  margin: 0;\n  box-sizing: border-box;\n  display: grid;\n  place-content: center;\n  font-family: system-ui, sans-serif;\n}\n\n@media (orientation: landscape) {\n  body {\n    grid-auto-flow: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
